import { render, staticRenderFns } from "./AtualizarCliente.vue?vue&type=template&id=5c97f06a&scoped=true&"
import script from "./AtualizarCliente.vue?vue&type=script&lang=js&"
export * from "./AtualizarCliente.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarCliente.vue?vue&type=style&index=0&id=5c97f06a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97f06a",
  null
  
)

export default component.exports